import { useTheme } from "@material-ui/core";
import React from "react";
import { ITheme } from "theme/ts/main";

export const WithToniqueColor = (TargetComponent: React.ComponentType<any>) => {
  const themeColor = (useTheme() as ITheme).palette.tonique;
  return <TargetComponent style={{ color: themeColor }} />;
};
